const body                  = document.querySelector('body');
const blocsVideo            = document.querySelectorAll('.js-adminArea')
const blocsVideoIframe      = document.querySelectorAll('.js-adminAreaIframe')

blocsVideo.forEach(function (blocVideo) {
    let figureArea          = blocVideo.querySelector('.js-adminAreaFigure')
    let popupArea           = blocVideo.querySelector('.js-popupArea')
    let popupAreaContainer  = blocVideo.querySelector('.js-popupAreaContainer')
    let openPopupArea       = blocVideo.querySelector('.js-open-popup')
    let closePopupArea      = blocVideo.querySelector('.js-close-popup')
    let video               = blocVideo.querySelector('video')

    function OpenPopupArea(popupArea) {
        popupArea.classList.add('js-open')
        body.classList.add('js-open_popupArea')
        // Check added class
        // console.log("add js-open")
    }

    function ClosePopupArea(popupArea) {
        popupArea.classList.remove('js-open')
        body.classList.remove('js-open_popupArea')
        // Check removed class
        // console.log("remove js-open")
        if (video) {
            video.pause();
        }
    }

    figureArea.addEventListener('click', function () {
        OpenPopupArea(popupArea)
        
        if (popupArea.classList.contains('js-open')) {
            document.addEventListener("mouseup", function(event) {
                if (!popupAreaContainer.contains(event.target)) {
                    ClosePopupArea(popupArea)
                    // console.log("test mouseup")
                }
            });
        }
        // console.log(popupArea.classList.contains('js-open'))
    })

    openPopupArea.addEventListener('click', function () {
        OpenPopupArea(popupArea)
    })

    closePopupArea.addEventListener('click', function () {
        ClosePopupArea(popupArea)
    })
});

blocsVideoIframe.forEach(function (blocVideoIframe) {
    let figureArea          = blocVideoIframe.querySelector('.js-adminAreaFigure')
    let popupArea           = blocVideoIframe.querySelector('.js-popupArea')
    let popupAreaContainer  = blocVideoIframe.querySelector('.js-popupAreaContainer')
    let openPopupArea       = blocVideoIframe.querySelector('.js-open-popup')
    let closePopupArea      = blocVideoIframe.querySelector('.js-close-popup')
    let videoIframeSrc      = blocVideoIframe.querySelector('iframe')

    figureArea.addEventListener('click', function () {
        if ( !videoIframeSrc.getAttribute('src') ) {
            videoIframeSrc.setAttribute('src', videoIframeSrc.getAttribute('data-src'));
        }
        
        if (popupArea.classList.contains('js-open')) {
            document.addEventListener("mouseup", function(event) {
                if (!popupAreaContainer.contains(event.target)) {
                    videoIframeSrc.removeAttribute('src')
                }
            });
        }
    })

    openPopupArea.addEventListener('click', function () {
        if ( !videoIframeSrc.getAttribute('src') ) {
            videoIframeSrc.setAttribute('src', videoIframeSrc.getAttribute('data-src'));
        }
    })

    closePopupArea.addEventListener('click', function () {
        videoIframeSrc.removeAttribute('src')
    })
});